<template>
  <div class="mt-3 pa-2 rounded elevation-0 bordered bg-grey_3">
    <div class="text-h6 mb-2">Finances</div>
    <div v-if="inscription.code_reduction && inscription.code_reduction.id">
      <v-chip variant="elevated" density="compact" elevation="0" color="primary-dark">Code promo: {{
        inscription.code_reduction.code_reduction_nom }}</v-chip>
    </div>
    <v-table class="bordered mt-2" density="compact" v-if="price_per_item.length > 0">
      <thead>
        <tr>
          <th class="text-left">Articles</th>
          <th class="text-left">Payé</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in price_per_item" :key="index">
          <td>
            {{ item.quantite }}x <b>{{ item.article }}</b>
          </td>
          <td v-if="parseFloat(item.price) == parseFloat(item.origin_price)">{{ item.price }}€</td>
          <td v-else>
            <span class="text-decoration-line-through">{{ item.origin_price }}€</span> <b>{{ item.price }}€</b>
          </td>
        </tr>
      </tbody>
    </v-table>

    <div v-if="inscription.code_reduction && inscription.code_reduction.id">
      <div class="my-2 font-weight-bold text-h6 text-right text-green-darken-4">SS TOTAL: {{ origin_price_total }}€
      </div>
      <div class="my-2 font-weight-bold text-h6 text-right text-red-darken-4">
        <v-chip variant="elevated" density="compact" elevation="0">{{ inscription.code_reduction.code_reduction_nom
        }}</v-chip> {{ inscription.code_reduction.valeur }}€
      </div>
      <div class="my-2 font-weight-bold text-h6 text-right text-green-darken-4">TOTAL: {{ price_total }}€</div>
    </div>
    <div v-else>
      <div class="my-2 font-weight-bold text-h6 text-right text-green-darken-4">TOTAL: {{ price_total }}€</div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Code_Reduction from "@/classes/Code_Reduction/Code_Reduction.class";
import List_Options from "@/classes/Options/List_Options.class";
import List_Activites from "@/classes/Activites/List_Activites.class";
import List_Articles_Boutique from "@/classes/Articles/List_Articles_Boutique.class";
export default {
  props: {
    inscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      applied_code: new Code_Reduction(),
      list_options: {},
      list_activites: {},
      list_articles: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
    price_per_item() {
      let items = [];
      if (this.inscription.commande_inscription && this.inscription.commande_inscription.id_item) {
        let course = this.get_course_name(this.inscription.commande_inscription.id_item);
        let price = this.inscription.commande_inscription.prix;

        if (this.applied_code.id) {
          price = this.applied_code.calcul_reduction(parseFloat(price), "course");
        }
        else if (this.applied_code.nom == 'DOSSARD OFFERT') {
          price = 0;
        }

        items.push({ article: course, quantite: 1, origin_price: this.inscription.commande_inscription.prix, price: price });
      }
      if (this.inscription.commande_options && this.inscription.commande_options.length > 0) {
        for (let i = 0; i < this.inscription.commande_options.length; i++) {
          if (this.inscription.commande_options[i].nom == 'Retrait sur place') {
            continue;
          }
          let option = this.get_option_name(this.inscription.commande_options[i].id_item, this.inscription.commande_options[i].type);
          if (this.inscription.commande_options[i].type == "article" && this.inscription.commande_options[i].size != '') {
            option += " - Taille " + this.inscription.commande_options[i].size;
          }
          let price = parseFloat(this.inscription.commande_options[i].prix);
          if (this.applied_code.id) {
            price = this.applied_code.calcul_reduction(parseFloat(price), "option");
          }
          items.push({ article: option, quantite: this.inscription.commande_options[i].quantite, origin_price: this.inscription.commande_options[i].prix, price: price });
        }
      }
      if (this.inscription.donation && this.inscription.donation.montant) {
        let donation = "Donation";
        let price = parseFloat(this.inscription.donation.montant);
        items.push({ article: donation, quantite: 1, origin_price: this.inscription.donation.montant, price: price });
      }
      return items;
    },
    price_total() {
      let total = 0;
      for (let i = 0; i < this.price_per_item.length; i++) {
        total += parseFloat(this.price_per_item[i].price);
      }
      return total;
    },
    origin_price_total() {
      let total = 0;
      for (let i = 0; i < this.price_per_item.length; i++) {
        total += parseFloat(this.price_per_item[i].origin_price);
      }
      return total;
    },
  },
  methods: {
    get_option_name(id, type) {
      if (type == "option") {
        if (!this.list_options.list) return "Option";
        for (let i = 0; i < this.list_options.list.length; i++) {
          if (this.list_options.list[i].id == id) {
            return this.list_options.list[i].nom;
          }
        }
      }
      if (type == "activite") {
        if (!this.list_activites.list) return "Activite";
        for (let i = 0; i < this.list_activites.list.length; i++) {
          if (this.list_activites.list[i].id == id) {
            return this.list_activites.list[i].nom;
          }
        }
      }
      if (type == "article") {
        if (!this.list_articles || !this.list_articles.list) return "Article";
        for (let i = 0; i < this.list_articles.list.length; i++) {
          if (this.list_articles.list[i].id == id) {
            return this.list_articles.list[i].nom;
          }
        }
      }
    },
    get_course_name(id) {
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].id == id) {
          return this.inscription.list_courses.list[i].nom;
        }
      }
    },
  },

  async mounted() {

    this.list_options = new List_Options(this.mainStore.module.id);
    this.list_options.initialize_from_mainstore(this.mainStore.module.options.list);
    this.list_activites = new List_Activites(this.mainStore.module.id);
    this.list_activites.initialize_from_mainstore(this.mainStore.module.activites.list);
    this.list_articles = new List_Articles_Boutique(this.mainStore.module.id);
    this.list_articles.initialize_from_mainstore(this.mainStore.module.articles_boutique.list);

    if (this.inscription.code_reduction && this.inscription.code_reduction.id) {
      this.applied_code.nom = this.inscription.code_reduction.code_reduction_nom;
      this.applied_code.id_module = this.mainStore.module.id;
      await this.applied_code.fetch_by_name(true);
    }
  },
};
</script>

<style lang="scss" scoped></style>